<template>
  <span>
    <div class="boss-layout-block">
      <dl class="boss-scout-send-wrap cleafix">
        <dt class="boss-scout-send-left">テンプレート</dt>
        <dd class="boss-scout-send-right">
          <select
            :value="selectedTemplateId"
            class="boss-input-select"
            @change="setSelectedTemplateMessage($event.target.value, selectedTemplateId)"
          >
            <option
              :value="null"
              data-test="template-option-none"
            >指定なし</option>
            <option
              v-for="(template, i) in templates"
              :key="i"
              :data-test="'template-option-' + i"
              :value="template.id"
            >{{ template.name }}
            </option>
          </select>
        </dd>
        <dt class="boss-scout-send-left">
          件名
          <small>（200文字以内）</small>
        </dt>
        <dd class="boss-scout-send-right">
          <input
            v-model="message.subject"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.subject)}"
            class="boss-send-subject"
            type="text"
            data-test="message-subject"
          >
          <validation-label
            v-if="hasTemplateReplacementCharacters(message.subject)"
            data-test="has-template-replacement-characters-subject"
            label="「●●【」または「】●●」が入力フォームに残っていると、送信することができません"
          />
        </dd>
        <dt class="boss-scout-send-left">本文<small>（10000文字以内）</small></dt>
        <dd class="boss-scout-send-right">
          <div class="boss-textarea-button">
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。'}"
              class="boss-button"
              data-test="user-name"
              @click="insertionValue('■USER_NAME■ 様')"
            >応募者名を挿入</button><span style="font-size: .8125rem;">（本文にのみ有効）</span>
          </div>
          <textarea
            ref="message"
            v-model="message.body"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.body)}"
            data-test="message-body"
            class="boss-send-textarea"
            rows
            cols
          />
          <validation-label
            v-if="hasTemplateReplacementCharacters(message.body)"
            data-test="has-template-replacement-characters-body"
            label="「●●【」または「】●●」が入力フォームに残っていると、送信することができません"
          />
        </dd>
      </dl>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <div class="boss-table-2">
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head primary">ステータス</div>
              <div
                class="boss-table-2-item boss-table-2-item-body"
                :class="{'pega-empty-select required' : message.isStatusChange === null }"
                data-test="update-status"
              >
                <div class="pega-input no-gray">
                  <input
                    v-model="message.isStatusChange"
                    :value="true"
                    type="radio"
                    class="boss-input-checkbox pega-input-button"
                    data-test="do-update-status"
                  >
                  <span @click="message.isStatusChange = true">
                    <span>送信後</span>
                    <select
                      v-model="message.statusId"
                      :disabled="!message.isStatusChange"
                      class="boss-send-select-template"
                      data-test="select-update-status"
                    >
                      <option :value="null">−</option>
                      <option
                        v-for="(status ,i) in seminarStatuses"
                        :key="i"
                        :value="status.id"
                      >{{ status.name }}
                      </option>
                    </select>
                    <span>に更新する</span>
                  </span>
                </div>
                <label class="pega-input">
                  <input
                    v-model="message.isStatusChange"
                    :value="false"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-not-update-status"
                  >
                  <span data-test="do-not-update-status-label">更新しない</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout boss-layout-center">
      <button
        :disabled="hasErrors"
        data-test="confirmation"
        class="boss-button boss-button-confirm pega-button"
        @click="onConfirmClick"
      >
        <span class="boss-button-confirm-text">送信内容を確認する</span>
      </button>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import ValidationLabel from '@/components/atoms/ValidationLabel'

export default {
  components: {
    ValidationLabel
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    entryIds: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      message: this.value,
      templates: [],
      selectedTemplateId: null
    }
  },
  computed: {
    hasTemplateReplacementCharacters () {
      return (val) => {
        return /●●【|】●●/.test(val)
      }
    },
    isEmpty () {
      return (val) => {
        return !_.isDate(val) && _.isEmpty(val) && !_.isNumber(val)
      }
    },
    ...mapGetters([
      'seminarStatuses'
    ]),
    isInvalid () {
      const validationItems = [
        {
          value: this.message.subject, isRequired: true
        },
        {
          value: this.message.body, isRequired: true
        }
      ]
      return _.some(validationItems, item => {
        return (_.get(item, 'isRequired') && this.isEmpty(item.value)) ||
        this.hasTemplateReplacementCharacters(item.value)
      })
    },
    hasErrors () {
      return this.isInvalid || _.isNull(this.message.isStatusChange)
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'message', val)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.fetchTemplates()
    },
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.message, 'body', this.message.body.substr(0, cursorPosition) + value + this.message.body.substr(cursorPosition, this.message.body.length))
    },
    onConfirmClick () {
      this.$emit('filledOut')
      this.$scrollTo('#message-register', 0, { offset: -35 })
    },
    fetchTemplates () {
      this.$http.secured.get('/company/entry/message/templates/_display').then(response => {
        this.$set(this, 'templates', response.data)
      })
    },
    fetchTemplate () {
      this.$http.secured.get(`/company/entry/message/templates/${this.selectedTemplateId}`).then(response => {
        const template = response.data
        this.$set(this.message, 'body', template.body)
        this.$set(this.message, 'subject', template.subject)
      })
    },
    setSelectedTemplateMessage (newId, oldId) {
      if (!newId) {
        // 「指定なし」が選択された場合は、selectedTemplateIdのみ更新
        this.$set(this, 'selectedTemplateId', null)
        return
      }

      if (!this.message.subject && !this.message.body) {
        // 件名・本文が未入力の場合にテンプレートが変更された場合は、テンプレートを反映
        this.$set(this, 'selectedTemplateId', newId)
        this.fetchTemplate()
        return
      }

      // 件名 または 本文が入力済みの場合にテンプレートが変更された場合は、確認ダイアログを出す
      this.$dialog.confirm('現在入力している件名・本文が削除されます。テンプレートを適応してよろしいですか？')
        // はいを押下した時：テンプレートを反映
        .then(() => {
          this.$set(this, 'selectedTemplateId', newId)
          this.fetchTemplate()
        })
        // いいえを押下した時：選択前の値に戻す
        .catch(() => {
          // 一度空更新しないと、同一の値とみなされてselectに反映されないため、空更新してからoldIdを連携
          this.$set(this, 'selectedTemplateId', '')
          this.$set(this, 'selectedTemplateId', oldId)
        })
    },
    reset () {
      this.$set(this, 'templates', [])
      this.$set(this, 'selectedTemplateId', null)
      this.init()
    }
  }
}
</script>
